import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { findText, SELECTOR } from "../helper/finder"
import { equipmentIsPipe, equipmentIsPsv, isElement, isParalelTransmission, isRedundantTransmission, isSerialTransmission } from "../helper/validator"
import { getTransmissionEndKey } from "../helper/transmission-end"
import { diagram } from '../constants'

export function handleElement(current: IRBDItem, prev: IRBDItem | undefined): IDiagramValues {
    let parent: number | number[] | undefined

    parent = handleElementParent(prev)

    const color = 
        (equipmentIsPipe(current) && diagram.node.color.pipe) ||
        (equipmentIsPsv(current) && diagram.node.color.psv) ||
        diagram.node.color.etc
    const strokeColor = 
        (equipmentIsPipe(current) && diagram.node.color.border.pipe) ||
        (equipmentIsPsv(current) && diagram.node.color.border.psv) ||
        diagram.node.color.border.etc
    
    return {
        color,
        strokeColor,
        figure: diagram.node.figure.rect,
        key: current.sequence,
        linkColor: diagram.link.color.show,
        text: findText(current),
        width: diagram.node.width.rect,
        containerWidth: diagram.node.width.rect + 2,
        parent: parent,
    }
}

export function handleElementParent(prev: IRBDItem | undefined): number | number[] | undefined {
    if (!prev) {
        return undefined
    }

    if (isElement(prev)) {
        return [prev.sequence]
    }

    if (isRedundantTransmission(prev)) {
        return [prev.sequence]
    }

    if (isSerialTransmission(prev)) {
        const elements = finder(prev, SELECTOR.TRANSMISSION_ELEMENTS)
        if (!Array.isArray(elements) || elements.length === 0) {
            return undefined
        }
        return [getTransmissionEndKey(elements[elements.length - 1])]
    }

    if (isParalelTransmission(prev)) {
        const elements = finder(prev, SELECTOR.TRANSMISSION_ELEMENTS)
        const parents = elements
            .map((i: IRBDItem) => handleElementParent(i))
            .flatMap((p: number | number[] | undefined) => Array.isArray(p) ? p : [])

        return parents.length > 0 ? parents : undefined
    }

    return undefined
}
